import {
  renderSvelteComponent,
  findSvelteComponentContainer,
} from './utils/render.js';

async function main() {
  // find the container
  /** @type {HTMLSelectElement | null} */
  const element = findSvelteComponentContainer('#nav-container');

  const dropdown = findSvelteComponentContainer('select#dropnav');

  if (dropdown) {
    dropdown?.addEventListener('change', (e) => {
      let getSelectedValue = e.target.value;
      // window.location.href = getSelectedValue;
      const targetElement = document.querySelector(getSelectedValue);

      if (targetElement) {
        // Get the top position of the target element relative to the document
        const targetPosition =
          targetElement.getBoundingClientRect().top + window.scrollY;

        // Scroll to the target position minus the offset
        window.scrollTo({
          top: targetPosition - 125,
          behavior: 'smooth',
        });
      }
    });
  }
}

main().catch(console.error);
